const getPassedDays = (date) => {
  const passedDays = (new Date().getTime() - new Date(date).getTime()) / (1000 * 3600 * 24);
  return passedDays;
};

export default getPassedDays;
